const initVal = null;

const AppliedJobsReducer = (state = initVal, action) => {
  switch (action.type) {
    case "SETAPPLIEDJOBS":
      return action.payload;
    case "DESTROYAPPLIEDJOBS":
      return initVal;
    case "UPDATEAPPLIEDJOBS":
      return { ...state, ...action.payload };
    default:
      return state;
  }
}

export default AppliedJobsReducer;
